/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MassTransitCommonSupportServiceAttachmentDataEncoding {
    Unspecified = 0,
    PlainText = 1,
    Base64 = 2,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfMassTransitCommonSupportServiceAttachmentDataEncoding(value: any): boolean {
    for (const key in MassTransitCommonSupportServiceAttachmentDataEncoding) {
        if (Object.prototype.hasOwnProperty.call(MassTransitCommonSupportServiceAttachmentDataEncoding, key)) {
            if (MassTransitCommonSupportServiceAttachmentDataEncoding[key as keyof typeof MassTransitCommonSupportServiceAttachmentDataEncoding] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MassTransitCommonSupportServiceAttachmentDataEncodingFromJSON(json: any): MassTransitCommonSupportServiceAttachmentDataEncoding {
    return MassTransitCommonSupportServiceAttachmentDataEncodingFromJSONTyped(json, false);
}

export function MassTransitCommonSupportServiceAttachmentDataEncodingFromJSONTyped(json: any, ignoreDiscriminator: boolean): MassTransitCommonSupportServiceAttachmentDataEncoding {
    return json as MassTransitCommonSupportServiceAttachmentDataEncoding;
}

export function MassTransitCommonSupportServiceAttachmentDataEncodingToJSON(value?: MassTransitCommonSupportServiceAttachmentDataEncoding | null): any {
    return value as any;
}

export function MassTransitCommonSupportServiceAttachmentDataEncodingToJSONTyped(value: any, ignoreDiscriminator: boolean): MassTransitCommonSupportServiceAttachmentDataEncoding {
    return value as MassTransitCommonSupportServiceAttachmentDataEncoding;
}

